// Canonical route name -> localized path per language.
// Only pages with real translated content get a `ro` entry — everything else
// (blog, portfolio, misc slider pages) stays a single English URL until translated.
export const localizedRoutes = {
  home: { en: '/', ro: '/ro' },
  about: { en: '/about', ro: '/ro/despre-noi' },
  contact: { en: '/contact', ro: '/ro/contact' },
  'web-development': { en: '/web-development', ro: '/ro/dezvoltare-web' },
  'cybersecurity-solutions': { en: '/cybersecurity-solutions', ro: '/ro/solutii-securitate-cibernetica' },
  'ai-secure-infrastructure': { en: '/ai-secure-infrastructure', ro: '/ro/infrastructura-ai-securizata' },
  'ai-red-teaming': { en: '/ai-red-teaming', ro: '/ro/ai-red-teaming' },
  'ai-systems-hardening': { en: '/ai-systems-hardening', ro: '/ro/securizare-sisteme-ai' },
  'custom-ai-development-and-automation': { en: '/custom-ai-development-and-automation', ro: '/ro/dezvoltare-ai-personalizata-automatizare' },
  'cookie-policy': { en: '/cookie-policy', ro: '/ro/politica-cookie' },
  'terms-and-conditions': { en: '/terms-and-conditions', ro: '/ro/termeni-si-conditii' },
};

const SITE_ORIGIN = 'https://iwebstudio-tech.com';

/** Path for `name` in `lang`, falling back to the English path if untranslated. */
export function localizedPath(name, lang) {
  const entry = localizedRoutes[name];
  if (!entry) return null;
  return lang === 'ro' ? (entry.ro || entry.en) : entry.en;
}

/** Absolute URL for `name` in `lang`. */
export function localizedUrl(name, lang) {
  const path = localizedPath(name, lang);
  return path ? `${SITE_ORIGIN}${path}` : null;
}

/** Given the current URL path, find its canonical route name, language, and counterpart path. */
export function findRouteByPath(path) {
  for (const [name, entry] of Object.entries(localizedRoutes)) {
    if (entry.en === path) return { name, lang: 'en', counterpart: entry.ro || null };
    if (entry.ro && entry.ro === path) return { name, lang: 'ro', counterpart: entry.en };
  }
  return null;
}

/** { en, ro, xDefault } absolute URLs for hreflang alternates on a given page. */
export function hreflangUrls(name) {
  const entry = localizedRoutes[name];
  if (!entry) return null;
  const en = `${SITE_ORIGIN}${entry.en}`;
  const ro = entry.ro ? `${SITE_ORIGIN}${entry.ro}` : null;
  return { en, ro, xDefault: en };
}
